/*
 * Copyright (c) 2026.
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in een bijbehorende schriftelijke overeenkomst met Spin in het Web B.V.
 */
import icons from 'quill/ui/icons';
import { BaseModule } from './BaseModule';
import Quill, {Parchment} from "quill";
import {hash} from "../../../types";
export class Toolbar extends BaseModule {
  FloatStyle!: Parchment.StyleAttributor;
  MarginStyle!: Parchment.StyleAttributor;
  DisplayStyle!: Parchment.StyleAttributor;
  toolbar!: HTMLDivElement;
  actions: hash<any>[] = [];
  alignments: hash<any>[] = [];
  override onCreate() {
    this.FloatStyle = new Parchment.StyleAttributor('float', 'float');
    this.MarginStyle = new Parchment.StyleAttributor('margin', 'margin');
    this.DisplayStyle = new Parchment.StyleAttributor('display', 'display');
    this.toolbar = document.createElement('div');
    Object.assign(this.toolbar.style, this.options.toolbarStyles);
    if (this.resizer.overlay) {
      this.resizer.overlay.appendChild(this.toolbar);
    }
    this._defineAlignments();
    this._defineActions();
    this._addToolbarButtons();
    this._addToolbarButtonsToActions();
  }
  _defineActions = () => {
    this.actions = [
      {
        icon: `<svg viewbox="0 0 18 18">
  <path class="ql-stroke" d="M9,3C5.686,3,3,5.239,3,8a4.669,4.669,0,0,0,2,3.719V15l3.094-2.063A7.186,7.186,0,0,0,9,13c3.314,0,6-2.239,6-5S12.314,3,9,3Z"></path>
</svg>`,
        apply: () => {
          if (!this.resizer.img) return;
          const findImg = <Parchment.Blot>Quill.find(this.resizer.img);
          const imgElement = <HTMLImageElement>findImg.domNode;
          const imgTitle = imgElement.alt;
          let title = prompt("Geef een alternatieve tekst voor deze afbeelding", imgTitle);
          if (title !== null) {
            imgElement.alt = title;
          }
        },
        isApplied: () => {
          if (!this.resizer.img) return false;
          const findImg = <Parchment.Blot>Quill.find(this.resizer.img);
          const imgElement = <HTMLImageElement>findImg.domNode;
          return imgElement.alt && imgElement.alt !== '';
        },
      },
    ]
  };
  _defineAlignments = () => {
    this.alignments = [
      {
        icon: icons.align[""],
        apply: () => {
          if (!this.resizer.img) return;
          this.DisplayStyle.add(this.resizer.img, 'inline');
          this.FloatStyle.add(this.resizer.img, 'left');
          this.MarginStyle.add(this.resizer.img, '0 1em 1em 0');
          this.resizer.onUpdate();
        },
        isApplied: () => this.resizer.img ? this.FloatStyle.value(this.resizer.img) == 'left' : false,
      },
      {
        icon: icons.align.center,
        apply: () => {
          if (!this.resizer.img) return;
          this.DisplayStyle.add(this.resizer.img, 'block');
          this.FloatStyle.remove(this.resizer.img);
          this.MarginStyle.add(this.resizer.img, 'auto');
          this.resizer.onUpdate();
        },
        isApplied: () => this.resizer.img ? this.MarginStyle.value(this.resizer.img) == 'auto' : false,
      },
      {
        icon: icons.align.right,
        apply: () => {
          if (!this.resizer.img) return;
          this.DisplayStyle.add(this.resizer.img, 'inline');
          this.FloatStyle.add(this.resizer.img, 'right');
          this.MarginStyle.add(this.resizer.img, '0 0 1em 1em');
          this.resizer.onUpdate();
        },
        isApplied: () => this.resizer.img ? this.FloatStyle.value(this.resizer.img) == 'right' : false,
      },
    ];
  };
  _addToolbarButtons = () => {
    const buttons: HTMLSpanElement[] = [];
    this.alignments.forEach((alignment, idx) => {
      const button: HTMLSpanElement = document.createElement('span');
      buttons.push(button);
      button.innerHTML = alignment['icon'];
      button.addEventListener('click', () => {
        buttons.forEach(button => button.style.filter = '');
        if (alignment['isApplied']() && this.resizer.img) {
          this.FloatStyle.remove(this.resizer.img);
          this.MarginStyle.remove(this.resizer.img);
          this.DisplayStyle.remove(this.resizer.img);
        } else {
          this._selectButton(button);
          alignment['apply']();
        }
        this.resizer.onUpdate();
      });
      Object.assign(button.style, this.options.toolbarButtonStyles);
      if (idx > 0) {
        button.style.borderLeftWidth = '0';
      }
      Object.assign((<HTMLElement>button.children[0]).style, this.options.toolbarButtonSvgStyles);
      if (alignment['isApplied']()) {
        this._selectButton(button);
      }
      this.toolbar.appendChild(button);
    });
  };
  _addToolbarButtonsToActions = () => {
    const buttons: HTMLSpanElement[] = [];
    this.actions.forEach((action, idx) => {
      const button = document.createElement('span');
      buttons.push(button);
      button.innerHTML = action['icon'];
      button.addEventListener('click', () => {
        buttons.forEach(button => button.style.filter = '');
        action['apply']();
        this.resizer.onUpdate();
      });
      Object.assign(button.style, this.options.toolbarButtonStyles);
      if (idx > 0) {
        button.style.borderLeftWidth = '0';
      } else if (idx === 0) {
        button.style.marginLeft = '10px';
      }
      Object.assign((<HTMLElement>button.children[0]).style, this.options.toolbarButtonSvgStyles);
      if (action['isApplied']()) {
        this._selectButton(button);
      }
      this.toolbar.appendChild(button);
    })
  };
  _selectButton = (button: HTMLElement) => {
    button.style.filter = 'invert(20%)';
  };
}
